module.exports = __webpack_public_path__ + "static/media/christmas-island.4bc5248b.png";